import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastController, AlertController, LoadingController, Events } from 'ionic-angular';

/*
  Generated class for the BaseProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ApiBaseProvider {

  // apiUrl: string = 'http://localhost:51001';
  apiUrl: string = 'https://api-e-learning-jpuc2.zetalabo.biz';

  constructor(
    protected http: HttpClient,
    protected toastController: ToastController,
    protected alertCtlr: AlertController,
    protected loadingController: LoadingController,
    protected events: Events,
  ) {
  }

  public getUser() {
    let user: any = JSON.parse(window.sessionStorage.getItem('user'));
    return user;

  }

  protected getHeaders() {

    let user: any = this.getUser();
    let token = (user && user.token)?user.token:'';
    let headers:any = {'Content-Type': 'application/json'};
    if (token) {
      headers['x-access-token'] = token;
    }
    console.log('*** headers ***');
    console.log(headers);
    return  new HttpHeaders(headers);
  }

  protected getHeadersForImage() {
    let user:any = JSON.parse(window.sessionStorage.getItem('user'));
    let token = (user && user.token)?user.token:'';
    let headers = {
      'x-access-token': token
    }
    return  new HttpHeaders(headers);
  }

  protected getParams(query) {
    let params: HttpParams = new HttpParams();
    for (const key of Object.keys(query)) {
      if (query[key]) {
        if (query[key] instanceof Array) {
          query[key].forEach((item) => {
            params = params.append(`${key.toString()}[]`, item);
          });
        } else {
          params = params.append(key.toString(), query[key]);
        }
      }
    }
    return params;
  }


  private error(error) {
    let data = (error)?error.error:{};

    let title = 'サーバエラー';
    let subTitle = '管理者にお問い合わせください';
    let message = '';
    if (data) {
      if (data.msg) subTitle = data.msg;
      if (data.errors) message = JSON.stringify(data.errors);
    }

    // メールアドレスの重複エラーの場合
    if (message.includes('11000 E11000 duplicate key error index: e_learning.users.$mail')) {
      title = '登録に失敗しました';
      subTitle = '過去に登録されたことのあるメールアドレスは、再登録することができません';
      message = '';
    }

    let confirm = this.alertCtlr.create({
      title: title,
      subTitle: subTitle,
      message: message,
      buttons: [{
        text: '確認',
        handler: () => {
        }
      }]
    });
    confirm.present();
  }


  private error401() {
    let confirm = this.alertCtlr.create({
      title: '認証エラー',
      subTitle: '認証に失敗しました。再度ログインしてください',
      buttons: [{
        text: '確認',
        handler: () => {
          this.events.publish('EVENT_LOGIN_ERROR');
        }
      }]
    });
    confirm.present();
  }

  protected async get(url:string, params:any = null) {
    let loading = this.loadingController.create();
    loading.present();

    let options: any = {headers: this.getHeaders()};
    if (params) {
      options.params = params;
    }
    return this.http.get(url, options)
    .toPromise().then((res:any) => {
      console.log(res);
      loading.dismiss();
      return res;
    }).catch((error:any) => {
      console.error(error);

      if (error.status === 401) {
        this.error401();
      } else {
        this.error(error);
      }

      loading.dismiss();
      return Promise.reject(error);
    })
  }
  protected async post(url:string, data:any, showLoading :boolean = true, showErrorMessage: boolean = true) {
    let loading;
    if (showLoading) {
      loading = this.loadingController.create();
      loading.present();
    }
    return this.http.post(url, data, { headers: this.getHeaders()})
    .toPromise().then((res:any) => {
      if (loading) loading.dismiss();
      return res;
    }).catch((error:any) => {
      if (loading) loading.dismiss();
      if (!showErrorMessage) return Promise.reject(error);

      if (error.status === 401) {
        this.error401();
      } else {
        this.error(error);
      }
      return Promise.reject(error);
    })
  }

  protected async delete(url:string) {
    let loading = this.loadingController.create();
    loading.present();
    return this.http.delete(url, { headers: this.getHeaders()})
    .toPromise().then((res:any) => {
      loading.dismiss();
      return res;
    }).catch((error:any) => {
      if (error.status === 401) {
        this.error401();
      } else {
        this.error(error);
      }


      loading.dismiss();
      return Promise.reject(error);
    })
  }


}



// WEBPACK FOOTER //
// ./src/providers/api-base-service/api-base-service.ts